import security from "@/main";
import Inc from "@/modules/inc/service/Inc";
import Core from "@/modules/core/service/Core";
import { getApiBaseUrl } from "@/config";

const url = {
    recipients: "/api/site/recipients",
    sendmail  : "/api/incident/{0}/send",
    template  : "/api/template/{0}",
};

export default {
    recipients (sites, typeId, statusId, companyId, roles, companyRoles) {
        return fetch(getApiBaseUrl() + url.recipients,{
            method : "POST",
            headers: security.jsonHeader() ,
            body   : JSON.stringify({
                siteIds       : sites.map(s => s.id),
                roleIds       : roles,
                typeId        : typeId,
                statusId      : statusId,
                companyId     : companyId,
                companyRoleIds: companyRoles
            }),
        })
            .then(data => security.response (data))
    },

    async mail (companyId, incident, index, stepId, status, to) {
        let mail = {
            incident   : incident.id,
            step       : stepId,
            to         : [],
            cc         : [],
            attachments: [],
            index      : index,
            template   : null,
            selected   : {
                to: to,
                cc: []
            }
        };

        await this.recipients(incident.sites, incident.typeId, status.id).then((recipients) => {
            recipients.forEach(r => {
                mail.to.push({
                    prefered: r.preferedTo,
                    contact : r.contact
                });

                mail.cc.push({
                    prefered: r.preferedCc,
                    contact : r.contact
                });
            });
        });

        return mail;
    },

    async initialize (sites, index, data, entry, incident, step, company, roles, companyRoles) {
        let mail = {
            incident   : incident.id,
            step       : step ? step.id : null,
            to         : [],
            cc         : [],
            attachments: [],
            index      : index,
            template   : null,
            selected   : {
                to: [],
                cc: []
            }
        };

        const companyId = company ? company.id : null;
        await this.recipients(sites, incident.typeId, entry.status.id, companyId, roles, companyRoles).then((recipients) => {
            recipients.forEach(r => {
                mail.to.push({
                    prefered: r.preferedTo,
                    contact : r.contact
                });

                mail.cc.push({
                    prefered: r.preferedCc,
                    contact : r.contact
                });
            });


            let highestRating = 0;
            for (let i = 0; i < recipients.length; i++) {
                const rating = recipients[i].rating;
                if (rating > highestRating) {
                    highestRating = rating;
                }
            }

            const to = [];
            const cc = [];

            const recipientsWithhighestRating = recipients.filter (r => r.rating === highestRating);
            if (recipientsWithhighestRating.length > 0 && recipientsWithhighestRating.length <= 3) {
                recipientsWithhighestRating.forEach (recipient => {
                    if (recipient.preferedTo) {
                        to.push (recipient.contact);
                    }

                    if (recipient.preferedCc) {
                        cc.push (recipient.contact);
                    }
                });
            }


            mail.selected.to = to;
            mail.selected.cc = cc;
       })

        return mail;
    },

    resolve (template, index, step, site, incident, success) {
        let unitsNames = "";
        incident.sites.forEach((unit,index,array) => {
            unitsNames += unit.fabricNo;
            if (index < array.length-1) {
                unitsNames += ", ";
            }
        });

        fetch(getApiBaseUrl() + url.template.replace("{0}", template), {
            method :'PUT',
            headers: security.jsonHeader(),
            body   : JSON.stringify({
                index   : index,
                step    : step,
                site    : site,
                incident: incident,
                misc    : {
                    units: unitsNames,
                }
            })
        })
            .then(data => security.response (data))
            .then(data => {
                success (data);
            })
    },

    sendMail (component, incident, bid, unitId, step, to, cc, subject, content, documents, success, error) {
        Core.method.putVoid(url.sendmail, {
            step     : step,
            bidId    : bid,
            unitId   : unitId,
            to       : to.map (t => t.email ? t.email : t),
            cc       : cc ? cc.map (t => t.email ? t.email : t) : null,
            subject  : subject,
            content  : content,
            documents: documents
        }, incident).then(() => {
            component.$bus.$emit(Inc.events.journal);
            if (success) success();
        }).catch((data) => {
            if (error) error(data);
        })
    },
}